import { Controller } from "@hotwired/stimulus"

// Toggles between the light ("grcreview") and dark ("grcreview-dark") DaisyUI
// themes. Persists the choice in localStorage under "gr-theme". The initial
// value is applied by an inline script in the layout <head> to avoid a flash
// of the wrong theme — this controller only handles subsequent toggling.
const LIGHT = "grcreview"
const DARK  = "grcreview-dark"
const KEY   = "gr-theme"

export default class extends Controller {
  static targets = ["sun", "moon", "label"]

  connect() {
    this.syncIcon()
  }

  toggle() {
    const next = this.#current() === DARK ? LIGHT : DARK
    document.documentElement.setAttribute("data-theme", next)
    try { localStorage.setItem(KEY, next) } catch (e) { /* ignore */ }
    this.syncIcon()
  }

  syncIcon() {
    const isDark = this.#current() === DARK
    if (this.hasSunTarget)  this.sunTarget.classList.toggle("hidden",  isDark)
    if (this.hasMoonTarget) this.moonTarget.classList.toggle("hidden", !isDark)
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = isDark ? "Switch to light mode" : "Switch to dark mode"
    }
  }

  #current() {
    return document.documentElement.getAttribute("data-theme") || LIGHT
  }
}
